import {
    Component,
    OnInit,
    Input,
    LOCALE_ID,
    Inject,
} from '@angular/core';
import { Observable, Subject, throwError } from 'rxjs';
import { tap, map, catchError } from 'rxjs/operators';

import { MainConfig } from '../../../conf/main.config';
import { AuthService } from './../../auth/auth.service';
import { LoginComponent } from '../../auth/login/login.component';
import { LogoutComponent } from '../../auth/logout/logout.component';
import { RegisterComponent } from '../../auth/register/register.component';
import { ProgramsComponent } from '../../programs/programs.component';
import { Program } from '../../programs/programs.models';
import { GncProgramsService } from '../../api/gnc-programs.service';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { SafeUrl } from '@angular/platform-browser';
import { ModalsTopbarService } from './modalTopbar.service';

@Component({
    selector: 'app-topbar',
    templateUrl: './topbar.component.html',
    styleUrls: ['./topbar.component.css'],
})
export class TopbarComponent implements OnInit {
    title: string = MainConfig.appName;
    // isLoggedIn: boolean = false;
    username: string;
    MainConfig = MainConfig;
    isCollapsed = true;
    programs$ = new Subject<Program[]>();
    isAdmin = false;
    isValidator = false;
    canSignup: boolean = MainConfig.signup !== 'never';
    adminUrl: SafeUrl;
    userAvatar: string;
    logoImage: string;
    hideAuth = false;
    languageMenuOpen = false;
    accountMenuOpen = false;
    currentLanguage = 'pt-BR';

    @Input()
    displayTopbar: boolean;

    constructor(
        @Inject(LOCALE_ID) readonly localeId: string,
        private route: ActivatedRoute,
        private programService: GncProgramsService,
        private auth: AuthService,
        private modalService: ModalsTopbarService,
        protected http: HttpClient
    ) {
        const savedLanguage = localStorage.getItem('language');
        this.currentLanguage = savedLanguage === 'fr' ? 'fr' : 'pt-BR';
        document.documentElement.lang = this.currentLanguage;

        const tmp = localStorage.getItem('username');
        this.username = tmp ? tmp.replace(/\"/g, '') : 'Anonymous';
        this.logoImage = MainConfig.API_ENDPOINT + '/media/logo.png';
        this.route.data
            .pipe(
                tap((data: { programs: Program[] }) => {
                    if (data && data.programs) {
                        this.programs$.next(data.programs);
                    } else {
                        // console.warn("topbar::getAllPrograms");
                        this.programService
                            .getAllPrograms()
                            .subscribe((programs) => {
                                this.programs$.next(programs);
                            });
                    }
                }),
                catchError((error) => throwError(error))
            )
            .subscribe();
        this.route.queryParams.subscribe((params) => {
            this.hideAuth = 'hideAuth' in params;
        });
    }

    isLoggedIn(): Observable<boolean> {
        return this.auth.authorized$.pipe(
            map((value) => {
                if (value === true) {
                    this.username = localStorage.getItem('username');
                    if (
                        localStorage.getItem('userAvatar') &&
                        localStorage.getItem('userAvatar') != 'null'
                    )
                        this.userAvatar =
                            MainConfig.API_ENDPOINT +
                            '/media/' +
                            localStorage.getItem('userAvatar');
                }
                return value;
            })
        );
    }

    login(): void {
        // O login e o cadastro usam modais separados, mas permitem alternar
        // entre si sem duplicar a lógica de abertura dentro dos componentes.
        this.modalService.open(LoginComponent, {
            size: 'lg',
            centered: true,
            windowClass: 'wikiprimes-login-modal',
            backdropClass: 'wikiprimes-login-backdrop',
        });

        // O serviço mantém a referência do modal aberto. Usamos essa referência
        // para saber quando o usuário pediu para trocar do login para o cadastro.
        if (this.modalService.modalRef) {
            this.modalService.modalRef.result.catch((reason) => {
                if (reason === 'switch-register') {
                    this.register();
                }
            });
        }
    }

    register(): void {
        this.modalService.open(RegisterComponent, {
            size: 'lg',
            centered: true,
            windowClass: 'wikiprimes-register-modal',
            backdropClass: 'wikiprimes-register-backdrop',
        });

        // A troca de tela fica centralizada na barra superior, evitando que os
        // componentes de autenticação criem modais uns dos outros.
        if (this.modalService.modalRef) {
            this.modalService.modalRef.result.catch((reason) => {
                if (reason === 'switch-login') {
                    this.login();
                }
            });
        }
    }

    logout(): void {
        this.modalService.open(LogoutComponent, {
            size: 'lg',
            centered: true,
        });
    }

    programs(): void {
        this.modalService.open(ProgramsComponent, {
            size: 'lg',
            windowClass: 'programs-modal',
            centered: true,
        });
    }

    toggleLanguageMenu(): void {
        this.languageMenuOpen = !this.languageMenuOpen;
        this.accountMenuOpen = false;
    }

    toggleAccountMenu(): void {
        this.accountMenuOpen = !this.accountMenuOpen;
        this.languageMenuOpen = false;
    }

    closeMenus(): void {
        this.accountMenuOpen = false;
        this.languageMenuOpen = false;
        this.isCollapsed = true;
    }

    setLanguage(language: 'pt-BR' | 'fr'): void {
        if (this.currentLanguage === language) {
            this.languageMenuOpen = false;
            return;
        }
        this.currentLanguage = language;
        localStorage.setItem('language', language);
        document.documentElement.lang = language;
        this.languageMenuOpen = false;
        window.location.reload();
    }

    t(portuguese: string, french: string): string {
        return this.currentLanguage === 'fr' ? french : portuguese;
    }

    ngOnInit(): void {
        const access_token = localStorage.getItem('access_token');
        if (access_token) {
            this.auth.ensureAuthorized().subscribe(
                (user) => {
                    if (user && user['features'] && user['features'].id_role) {
                        this.username = user['features'].username;
                        this.isAdmin = user['features'].admin ? true : false;
                        this.isValidator = user['features'].validator;
                        if (this.isAdmin) {
                            const ADMIN_ENDPOINT = [
                                MainConfig.API_ENDPOINT,
                                // this.localeId,
                                'admin',
                                '',
                            ].join('/');
                            // const PROGRAM_ENDPOINT = ADMIN_ENDPOINT + "programsmodel/";
                            // this.adminUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
                            //   PROGRAM_ENDPOINT + "?jwt=" + this.auth.getAccessToken()
                            // );
                            this.adminUrl = ADMIN_ENDPOINT;
                        }
                    }
                },
                (err) => {
                    console.error(err);
                    this.auth
                        .logout()
                        .then((_logout) => {
                            // console.log('Logout Status:', logout.status);
                        })
                        .catch((_err) => {
                            // console.error('Logout error:', err);
                        });
                    return throwError(err);
                }
            );
        }
    }
}
